import { Button, Checkbox, Col, Collapse, Form, Input, Modal, Row, Typography } from "antd";


import InputMask from 'react-input-mask';

import { useEffect, useState } from "react";
import SelectPlatformPartial from "../../../components/SelectPlatform";


import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();
const { Title, Paragraph } = Typography;
const { Panel } = Collapse;
function User({ data }) {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [verificationCodeSending, setVerificationCodeSending] = useState(false);
  const [disabledAgencyFields, setDisabledAgencyFields] = useState([]);

  const onFinish = async (values) => {
    setVerificationCodeSending(true);
    const unformattedPhoneNumber = values.phoneNumber;
    const e164ContactPhoneNumberObject = phoneUtil.parseAndKeepRawInput(unformattedPhoneNumber, 'US');
    const e164ContactPhoneNumber = phoneUtil.format(e164ContactPhoneNumberObject, PhoneNumberFormat.E164);
    const verificationData = {
      contactPhoneNumber: e164ContactPhoneNumber
    };
    const requestOptions = {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(verificationData)
    };
    data.setValues(values);
    const response = await fetch(process.env.REACT_APP_SEND_PHONE_NUMBER_VERIFICATION_CODE_ENDPOINT ?? "", requestOptions);
    setVerificationCodeSending(false);

    if (response.status !== 200) {
      form.setFields([
        {
          name: "phoneNumber",
          errors: ["Failed to send verification code. Please try again."],
        },
      ]);
      return;
    }

    data.changeStep("validatePhone");
  };

  const onFinishFailed = (values) => {
    console.log("we're gonna do some calls here");
  };

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = e => {
    setVisible(false);
  };

  const handleCancel = e => {
    setVisible(false);
  };

  useEffect(() => {
    const fetchRegistrationSession = async (uuid) => {
      const baseUrl = process.env.REACT_APP_REGISTRATION_SESSION_ENDPOINT ?? "";
      if (!baseUrl) {
        return;
      }

      const requestOptions = {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(`${baseUrl}/${uuid}`, requestOptions);
      if (response.status !== 200) {
        console.error("Failed to fetch registration session");
        return;
      }
      const sessionData = await response.json();
      if (!data.companyName) {
        data.setValues({ companyName: sessionData.companyName });
        form.setFieldsValue({ companyName: sessionData.companyName });
      }

      if (sessionData.isAgencyAccount) {
        data.setValues({ contactId: sessionData.infusionsoftContactId, pricingPlanId: sessionData.pricingPlanId, creditCardId: sessionData.infusionsoftCreditCardId, isAgencyAccount: true });
        const fieldsToDisable = [];
        if (sessionData.firstName) {
          data.setValues({ firstName: sessionData.firstName });
          form.setFieldsValue({ firstName: sessionData.firstName });
          fieldsToDisable.push("firstName");
        }

        if (sessionData.lastName) {
          data.setValues({ lastName: sessionData.lastName });
          form.setFieldsValue({ lastName: sessionData.lastName });
          fieldsToDisable.push("lastName");
        }

        if (sessionData.email) {
          data.setValues({ email: sessionData.email });
          form.setFieldsValue({ email: sessionData.email });
          fieldsToDisable.push("email");
        }

        setDisabledAgencyFields(fieldsToDisable);

      } else {
        data.setValues({ existingCreditCards: sessionData?.creditCards || [] });
      }
    };

    if (data.sessionUuid) {
      fetchRegistrationSession(data.sessionUuid);
    }
  }, [data.sessionUuid]);

  return (
    <div>
      <Form
        form={form}
        name="basic"
        layout="vertical"
        initialValues={{
          remember: true
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              initialValue={data.firstName}
              label="First Name"
              name="firstName"
              rules={[
                {
                  required: true,
                  message: "Please input your First Name!",
                },
              ]}
            >
              <Input disabled={disabledAgencyFields.includes("firstName")} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              initialValue={data.lastName}
              label="Last Name"
              name="lastName"
              rules={[
                {
                  required: true,
                  message: "Please input your Last Name!",
                },
              ]}
            >
              <Input disabled={disabledAgencyFields.includes("lastName")} />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          initialValue={data.companyName}
          label="Company Name"
          name="companyName"
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: "Please input your Company Name!"
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          initialValue={data.email}
          label="Email"
          name="email"
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: "Please input your Email!"
            },
            {
              validator(_, value) {
                if (!value || value.match(/^\S+@\S+\.\S+$/)) {
                  return Promise.resolve();
                }
                return Promise.reject("Please enter a valid email");
              }
            }
          ]}
        >
          <Input disabled={disabledAgencyFields.includes("email")} />
        </Form.Item>

        <Form.Item
          label="Phone Number"
          initialValue={data.phoneNumber}
          name="phoneNumber"
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: "Please input your phone number!"
            },
          ]}
        >
          <InputMask mask="+1 (999) 999-9999" maskChar=" " >
            {(inputProps) => <Input {...inputProps} />}
          </InputMask>
        </Form.Item>

        {/* only show password fields if no session_uuid */}
        {!data.sessionUuid && (
          <>
            <Form.Item
              label="Password"
              name="password"
              initialValue={data.password}
              validateTrigger="onBlur"
              rules={[
                {
                  required: true,
                  message: "Please input your Password!",
                },
                () => ({
                  validator(_, value) {
                    if (
                      !value ||
                      value.match(/^(?=.*[A-Za-z])(?=.*\d).{8,}$/)
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      "Password must be minimum eight characters, at least one letter and one number."
                    );
                  },
                }),
              ]}
              hasFeedback
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              label="Confirm Password"
              name="passwordConfirmation"
              initialValue={data.passwordConfirmation}
              dependencies={['password']}
              hasFeedback
              validateTrigger="onBlur"
              rules={[
                {
                  required: true,
                  message: "Please confirm your Password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      "The two passwords that you entered do not match!"
                    );
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
          </>
        )}


        <Form.Item
          label="Select Platform"
          name="platformName"
          initialValue={data.platformName}
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: "Please Select Platform!"
            }
          ]}
        >
          <SelectPlatformPartial />
        </Form.Item>

        <Form.Item
          initialValue={data.acceptedConditions}
          name="acceptedConditions"
          valuePropName="checked"
          rules={[
            {
              required: true,
              message: "You must accept the terms and conditions!",
            },
          ]}
        >
          <Checkbox>
            I accept the <a href="https://www.yetitext.com/terms-of-service" target="_blank" rel="noopener noreferrer">terms and conditions</a>.
          </Checkbox>
        </Form.Item>

        <Form.Item className="flex justify-end">
          <Button type="primary" htmlType="submit" disabled={verificationCodeSending} loading={verificationCodeSending}>
            {!verificationCodeSending && "Next"}
          </Button>
        </Form.Item>

        <Button type="link" onClick={showModal}>
          Why do we need your phone number?
        </Button>

        <Modal
          open={visible}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <Typography>
            <Title level={3}>Why We Need Your Phone Number</Title>
            <Paragraph>
              In order to ensure a high level of security and provide you with reliable service, we require your valid phone number during registration.
            </Paragraph>
            <Paragraph>
              As part of the 10DLC (10 Digit Long Code) regulations, a valid phone number is needed to ensure accurate and efficient messaging services.
            </Paragraph>

            <Collapse defaultActiveKey={['1']}>
              <Panel header="View More Reasons" key="1">
                <Paragraph>
                  <ul>
                    <li><b>Verify Your Identity:</b> We'll send a unique code to your phone number to verify your account upon registration.</li>
                    <li><b>Communicate Effectively:</b> Your phone number allows us to send important updates, notifications, or respond to your inquiries more promptly.</li>
                    <li><b>Secure Your Account:</b> As an added layer of security, we may use your phone number for two-factor authentication or password recovery.</li>
                    <li><b>Prevent Fraudulent Activity:</b> Requiring a phone number can help to prevent multiple account creations and maintain the integrity of our platform.</li>
                  </ul>
                </Paragraph>
              </Panel>
            </Collapse>
          </Typography>

        </Modal>
      </Form>
    </div>
  );
}

export default User;
